import { client } from '@/shared/http/client';

import { ENDPOINT, type OrderRating, type RatingSource } from '../types/rate-order';

/** PRAT-111 — último pedido que ainda dá para avaliar (faixa da home e da loja). */
export type PendingRating = {
  id: string;
  display_id: string | number | null;
  ratable_until: string;
  merchant: { id: string; name: string | null; slug: string | null; image: string | null };
};

export async function getPendingRating(slug?: string): Promise<PendingRating | null> {
  const res = await client
    .get('api/app/orders/pending-rating', {
      searchParams: slug ? { slug } : undefined,
    })
    .json<{ order: PendingRating | null }>();
  return res.order ?? null;
}

/** Nota de 1 toque (sem comentário): o comentário vem depois, se o cliente quiser. */
export async function rateOrderWithSource(
  orderId: string,
  rating: number,
  source: RatingSource
): Promise<OrderRating> {
  return client.post(ENDPOINT(orderId), { json: { rating, source } }).json<OrderRating>();
}

export async function commentOrderRating(orderId: string, comment: string): Promise<OrderRating> {
  return client.put(ENDPOINT(orderId), { json: { comment } }).json<OrderRating>();
}
